import React from "react";
import styled from "styled-components";

import {getConfig} from "../../../../../utils/config"

const config = getConfig();

const navbar = config.theme.navbar;

const Nav = styled.nav`
  width: ${navbar.width};
  background-color: ${navbar.backgroundColor};
  color: #ffffff;
  height: 100vh;
  overflow-y: auto;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  transition: transform 0.3s ease-in-out;

  @media (max-width: 768px) {
    transform: ${(props) =>
      props.open ? "translateX(0)" : "translateX(-100%)"};
    position: fixed;
  }
`;

export default Nav;


// WEBPACK FOOTER //
// ./src/views/AppViews/Sidebar/components/Nav/index.jsx